import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { AccelerationTasks } from '~src/dataAcceleration/resources/AccelerationTasks';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { AccelerationTaskContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const AccelerationTaskDefinition: ExplorableItemDefinition = {
  itemType: 'accelerationTask',
  pluralName: Messages.accelerationTasks,
  singularName: Messages.accelerationTask,
  emptyStateMessage: Messages.accelerationTasksEmptyMessage,
  contentFilterKeys: AccelerationTaskContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['accelerationTask']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return AccelerationTasks.all().withExtraParams(AccelerationTaskContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
